/* eslint-disable import/no-unresolved */
const languages = {
  pl: import('./pl_PL.json').catch(() => ({ default: {} })),
};

export default languages;
